import { render, staticRenderFns } from "./AlphabetView.vue?vue&type=template&id=82ed8ca6&scoped=true&"
import script from "./AlphabetView.vue?vue&type=script&lang=js&"
export * from "./AlphabetView.vue?vue&type=script&lang=js&"
import style0 from "./AlphabetView.vue?vue&type=style&index=0&id=82ed8ca6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ed8ca6",
  null
  
)

export default component.exports